import * as CommentActionTypes from '../../../constants/comments/CommentActionTypes';

const initialState = {
    searchKeyword: '',
    searchType: 'writer',
};

export default (state = initialState, action) => {
    switch (action.type) {
        case CommentActionTypes.CLEAR_ITEMS:
            return {
                searchKeyword: '',
                searchType: 'writer',
            };
        case CommentActionTypes.SEARCH_KEYWORD:
            return Object.assign({}, state, {
                searchKeyword: action.searchKeyword,
                searchType: action.searchType,
            });
        default :
            return state;
    }
}
